/* tslint:disable */
/* eslint-disable */
/**
 * API SPECS
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { InfantOneYearOld } from './InfantOneYearOld';
import {
    InfantOneYearOldFromJSON,
    InfantOneYearOldFromJSONTyped,
    InfantOneYearOldToJSON,
} from './InfantOneYearOld';
import type { PaginationInfo } from './PaginationInfo';
import {
    PaginationInfoFromJSON,
    PaginationInfoFromJSONTyped,
    PaginationInfoToJSON,
} from './PaginationInfo';

/**
 * 
 * @export
 * @interface InfantOneYearOldPagination
 */
export interface InfantOneYearOldPagination {
    /**
     * 
     * @type {Array<InfantOneYearOld>}
     * @memberof InfantOneYearOldPagination
     */
    data?: Array<InfantOneYearOld>;
    /**
     * 
     * @type {PaginationInfo}
     * @memberof InfantOneYearOldPagination
     */
    meta?: PaginationInfo;
}

/**
 * Check if a given object implements the InfantOneYearOldPagination interface.
 */
export function instanceOfInfantOneYearOldPagination(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function InfantOneYearOldPaginationFromJSON(json: any): InfantOneYearOldPagination {
    return InfantOneYearOldPaginationFromJSONTyped(json, false);
}

export function InfantOneYearOldPaginationFromJSONTyped(json: any, ignoreDiscriminator: boolean): InfantOneYearOldPagination {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(InfantOneYearOldFromJSON)),
        'meta': !exists(json, 'meta') ? undefined : PaginationInfoFromJSON(json['meta']),
    };
}

export function InfantOneYearOldPaginationToJSON(value?: InfantOneYearOldPagination | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(InfantOneYearOldToJSON)),
        'meta': PaginationInfoToJSON(value.meta),
    };
}

